export default __webpack_public_path__ + "static/about-img10-dd934566ecfbfbe5739f6065076654b8.png";